import { queryOptions } from "@tanstack/react-query";
import { APIFunction } from "../utils/apiFunction";

export function getAllTranslationsQuery(shopifyDomain: string, previewThemeId: string | null, locale: string) {
    return queryOptions({
        queryKey: ["getAllTranslations"],
        queryFn: () => APIFunction.getAllTranslations(shopifyDomain, previewThemeId, locale),
    });
}

export function getTranslationsByTypesQuery(shopifyDomain: string, locale: string, types: string) {
    return queryOptions({
        queryKey: ["getTranslationsByTypes"],
        queryFn: () => APIFunction.getTranslationsByType(shopifyDomain, locale, types),
    });
}

export function getCancellationOffersShortDescriptionQuery(shopifyDomain: string, locale: string | null) {
    return queryOptions({
        queryKey: ["getCancellationOffersShortDescription"],
        queryFn: () => APIFunction.getCancellationOffersShortDescription(shopifyDomain, locale),
    });
}
